module.exports = __webpack_public_path__ + "img/user.9887fca0.png";